// API Configuration
// Dynamische URL-Ermittlung für Produktions-Kompatibilität
const getBackendUrl = () => {
  // PRIORITÄT 1: Globale Variable aus index.html (vor React-Load gesetzt)
  if (typeof window !== 'undefined' && window.CORRECTED_API_URL) {
    return window.CORRECTED_API_URL;
  }
  
  // PRIORITÄT 2: Production Domain Check - verwende window.location.origin
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Für Production-Domain (babelmix.com) verwende die aktuelle Origin
    if (hostname.includes('babelmix.com')) {
      return window.location.origin;
    }
  }
  
  // PRIORITÄT 3: Umgebungsvariable
  return process.env.REACT_APP_BACKEND_URL;
};

// WICHTIG: Diese Funktionen werden bei JEDEM Aufruf neu evaluiert
// Das stellt sicher, dass auf Production immer die richtige URL verwendet wird
export const getApiUrl = () => `${getBackendUrl()}/api`;

// Für Rückwärtskompatibilität: API und BACKEND_URL 
// Diese nutzen die globale Variable wenn verfügbar
const getInitialApi = () => {
  // Prüfe auf globale Production-API aus index.html
  if (typeof window !== 'undefined' && window.PRODUCTION_API) {
    return window.PRODUCTION_API;
  }
  return `${getBackendUrl()}/api`;
};

// Exportiere als Konstanten für Rückwärtskompatibilität
export const BACKEND_URL = getBackendUrl();
export const API = getInitialApi();

// Production URL for redirects - dynamisch ermittelt
export const getProductionUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname.includes('babelmix.com')) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};
export const PRODUCTION_URL = getProductionUrl();
export const EXPECTED_BACKEND = 'babelmix.com';

// Debug mode - OFF for production
export const DEBUG_SHOW_URLS = false;

// ============================================
// RETRY CONFIGURATION für Server-Stabilität
// ============================================

// Fehler-Codes die einen Retry auslösen sollen
export const RETRYABLE_STATUS_CODES = [500, 502, 503, 520, 521, 522, 524];

// Retry-Konfiguration
export const RETRY_CONFIG = {
  maxRetries: 3,
  baseDelay: 1000, // 1 Sekunde
  maxDelay: 10000, // 10 Sekunden max
  backoffMultiplier: 2
};

// Berechne Delay mit exponential backoff
export const calculateRetryDelay = (attempt) => {
  const delay = Math.min(
    RETRY_CONFIG.baseDelay * Math.pow(RETRY_CONFIG.backoffMultiplier, attempt),
    RETRY_CONFIG.maxDelay
  );
  // Füge etwas Jitter hinzu um Thundering Herd zu vermeiden
  return delay + Math.random() * 500;
};

// Prüfe ob ein Fehler retry-fähig ist
export const isRetryableError = (error) => {
  if (!error.response) {
    // Netzwerkfehler - retry
    return true;
  }
  return RETRYABLE_STATUS_CODES.includes(error.response.status);
};

// Sleep-Funktion für Delays
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Make DEBUG_SHOW_URLS available globally for legacy components
if (typeof window !== 'undefined') {
  window.DEBUG_SHOW_URLS = DEBUG_SHOW_URLS;
}

